import { Card, PageHeader, StatusView } from '@/components/ui';
import { appModules } from '@/app/modules';

/**
 * The signposted home of a module that is planned but not built.
 *
 * Every entry is driven from the module registry, so shipping the real
 * implementation means replacing one route — the navigation, the title and
 * the description already exist.
 */
export function ModulePlaceholderPage({ moduleId }: { moduleId: string }) {
  const module = appModules.find((entry) => entry.id === moduleId);

  return (
    <>
      <PageHeader
        eyebrow="Analysis"
        title={module?.label ?? 'Module'}
        description={module?.description}
      />
      <Card>
        <StatusView
          icon={module?.icon ?? 'layers'}
          tone="accent"
          title="Planned for a future release"
          message="This module has a reserved route and navigation entry. The application's architecture is built so it can be added without restructuring anything that already works."
        />
      </Card>
    </>
  );
}
